import { z } from 'zod';

export const DisableAutopaySettings = z.object({
  enabled: z.boolean(),
  reasonSettings: z.object({
    r01: z.boolean(),
    allOtherRCodes: z.boolean(),
  }),
});
export type DisableAutopaySettings = z.infer<typeof DisableAutopaySettings>;

export const DEFAULT_DISABLE_AUTOPAY_SETTINGS: DisableAutopaySettings = {
  enabled: true,
  reasonSettings: {
    r01: true,
    allOtherRCodes: true,
  },
};
